import React, { ReactNode, Fragment } from "react";
import { isEmpty } from "bodycodi/cmap/app/js/common";
import icon_x_medium from "bodycodi/cmap/app/svg/icon_x_medium.svg";

type PickerTopProp = {
  title: string;
  onClose: () => void;
  children?: ReactNode;
};

function PickerTop({ title = "", onClose, children }: PickerTopProp) {
  return (
    <div className="picker-header">
      <div className="title">
        {!isEmpty(title) && title}
        {isEmpty(title) && <Fragment>{children}</Fragment>}
      </div>
      <div className="close" onClick={onClose}>
        <img src={icon_x_medium} alt="" />
      </div>
    </div>
  );
}

export default PickerTop;
